// export const PROD_URL = "https://dev.jiitu.co.id";
export const PROD_URL = "https://piawaindonesia.id";
export const DEV_URL = "http://jitudevus.pex";
